// #224 — surface which commit this frontend bundle was built from, so a stale
// deploy (vs. the backend's live `/health` commit) is visible rather than
// requiring Render-API archaeology.
//
// `REACT_APP_BUILD_COMMIT` is baked in at build time via Vite's `define` (see
// vite.config.mjs) from Render's `RENDER_GIT_COMMIT` — the same env var the
// backend reads for its own `/health` response. Local dev builds/serves without
// that env var, so it falls back to "unknown" (never fabricated).
export const FRONTEND_BUILD_COMMIT = process.env.REACT_APP_BUILD_COMMIT || 'unknown';

// Fetches the backend's own reported commit from `/health` (root-level route,
// not under `/api` — mirrors AppBoot.js's health-check URL derivation) so a
// mismatch after a partial deploy (frontend shipped, backend still old, or
// vice versa) is visible. Returns null on any failure — callers should treat
// that as "unknown", not surface an error for a nice-to-have diagnostic.
export async function fetchBackendVersion(apiBaseUrl) {
  try {
    const origin = apiBaseUrl.replace(/\/api\/?$/, '');
    const response = await fetch(`${origin}/health`);
    if (!response.ok) return null;
    const body = await response.json();
    return body?.version || null;
  } catch {
    return null;
  }
}
